<template>
    <div class="profile-post-item">
        <div class="title">
            <router-link :to="{path: '/topics/' + this.post.topicID}">{{ post.topicTitle | decodeHtml }}</router-link>
            <div class="timestamp">{{ post.postDateUTC | localDateTime }}</div>    
        </div>
        <div class="content" v-html="post.content"></div>
    </div>
</template>

<script>
    export default {
        props: ['post']
    }
</script>